const checkForPendingMigrations = (saveResponse) => {
  if (!saveResponse) return false;

  const { data: { hasPendingMigrations } = {} } = saveResponse;

  return !!hasPendingMigrations;
};

export default checkForPendingMigrations;
